// EDIT WITH PUS
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// material ui components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';

import isNumeric from 'validator/lib/isNumeric';
import InputAdornment from '@material-ui/core/InputAdornment';

import CircularProgress from '@material-ui/core/CircularProgress';
//icons
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
//icons
import SaveIcon from '@material-ui/icons/Save';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Slide from '@material-ui/core/Slide';

import { usePouchDB } from '../../../../components/PouchDB/PouchDBProvider';
import { Swipeable } from 'react-swipeable';
//styles
import useStyles from '../kb/subforms/styles';
import { useSnackbar } from 'notistack';

//date utils
import parseDate from 'date-fns/parse';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

import { sub } from 'pouchdb-find';

import { countAge } from '../pk/validation';

export const formatString = "dd-MM-yyyy";

function Hamil({ wilayah, id, keluarga, kb, mainSlide, hamilPertamaLainnya, setHamilPertamaLainnya, handleNext, handleBack, handleDraft, handleSegmen, handleAnomali, mode, pertanyaanPus, jmlHamilLainnya, setJmlHamilLainnya }) {
    const classes = useStyles();
    const nextRef = useRef(null);
    const backRef = useRef(null);

    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = useState({})

    const { user: { metadata }, dataKK, dataPK, dataKB, dataBkkbn } = usePouchDB();
    const [isSomethingChange, setSomethingChange] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [isSaved, setSaved] = useState({
        local: false,
        remote: false
    })

    let valIndex = 0
    //action draft
    if (wilayah.status_draft == 1 && wilayah.pos_draft == 4 && wilayah.subformIndex !== undefined) {
        valIndex = wilayah.subformIndex
    }
    const [subformIndex, setSubFormIndex] = useState(valIndex);

    const [navigationMode, setNavigationMode] = useState('next');
    const [slide, setSlide] = useState({
        direction: "left",
        in: true
    });

    const [sedang_hamil, setHamil] = useState(hamilPertamaLainnya || '')
    const [jml_hamil, setJmlHamil] = useState(jmlHamilLainnya || '')
    const [jmlKeluarga, setJmlKeluarga] = useState(0)
    const [wifeExists, setWifeExists] = useState(false);

    useEffect(() => {

        if (pertanyaanPus !== "1") {
            setHamilPertamaLainnya('')
            setJmlHamilLainnya('')
            if (mainSlide.navigationMode === "next") {
                handleNext();
            } else {
                handleBack()
            }
        } else {

            let cek_keluarga_lainnya = false
            let total = Object.keys(keluarga)
            let jml = 0;
            if (total.length > 0) {
                for (let index = 1; index <= total.length; index++) {

                    let umur = ageConvert(keluarga[index].tgl_lahir)
                    if (keluarga[index].jenis_kelamin === "2") {
                        if (Math.ceil(umur) >= 10 && Math.ceil(umur) <= 49) {
                            cek_keluarga_lainnya = true
                            jml++;
                        }
                    }
                }

                console.log("jml keluarga => ", jml)

                setWifeExists(true)
                setJmlKeluarga(jml)

                if (!cek_keluarga_lainnya) {
                    setHamilPertamaLainnya('')
                    setJmlHamilLainnya('')
                    if (mainSlide.navigationMode === "next") {
                        handleNext();
                    } else {
                        handleBack()
                    }
                }
            } else {
                setHamilPertamaLainnya('')
                setJmlHamilLainnya('')
                if (mainSlide.navigationMode === "next") {
                    handleNext();
                } else {
                    handleBack()
                }
            }

        }

    }, [])

    useEffect(() => {
        setHamilPertamaLainnya(sedang_hamil)
        setJmlHamilLainnya(jml_hamil)
    }, [sedang_hamil, jml_hamil])

    function countAgeMonth(tgl_lahir) {
        const days = differenceInCalendarDays(new Date(), parseDate(tgl_lahir, formatString, new Date()));

        const month = days / 30.41;
        return parseInt(month);
    }

    const ageConvert = (tgl_lahir) => {
        const month = countAgeMonth(tgl_lahir);//days / 365;
        let umur = month / 12

        // if (month > 720)
        return umur;
    }

    if (!wifeExists) {
        return null;
    }

    const handleCheckSegmen = async (event) => {
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {
            if (subformIndex === 0) {
                enqueueSnackbar("Silahkan Klik Selanjutnya", { variant: 'warning' })
            } else {

                const { value } = event.target;
                // console.log(wilayah.status_draft, "status_draft")
                // const x = Object.keys(keluarga).length;
                const x = parseInt(wilayah.jumlah_keluarga);
                // console.log(x, 'jml kel')
                if (value) {
                    let val = parseInt(value);
                    // console.log(val, 'val parseint')
                    if (x > 1) {
                        (val > 1) ? val = val + x - 1 : val = val
                    }

                    let segment_pus = wilayah.pertanyaan_pus || ''
                    if ((x === 1 && val === 2) || (segment_pus !== 1 && value === 4)) {
                        console.log("masuk if kb")
                        let message
                        if (val === 2) {
                            message = `Data KB tidak Tersedia`
                        } else {
                            message = `Data Stunting tidak Tersedia`
                        }

                        enqueueSnackbar(message, { variant: "warning" })
                    } else {
                        // console.log("masuk jmlklg" + x + "val" + val)
                        handleSegmen(event, val)
                    }
                }
            }

        }

    }

    const validate = () => {
        let newError = {};

        if (!sedang_hamil) {
            newError.sedang_hamil = "Wajib diisi";
        }

        if (sedang_hamil === "1") {
            if (!jml_hamil) {
                newError.jml_hamil = "Jumlah keluarga harus diisi";
            } else if (!isNumeric(jml_hamil)) {
                newError.jml_hamil = "harus diisi dengan angka";
            } else if (parseInt(jml_hamil) <= 0 || parseInt(jml_hamil) > jmlKeluarga) {
                newError.jml_hamil = "Jumlah keluarga > jumlah keluarga lainnya";
            }
        }

        return newError;

    }

    const pertanyaan = "Apakah ada anggota keluarga yang sedang hamil anak pertama ?";

    const handleChange = (e) => {

        if (e.target.type === "number" && parseInt(e.target.value) < 0) {
            return false;
        }

        if (e.target.name === "jml_hamil" && e.target.value.length > 2) {
            return false;
        }

        if (e.target.name === "jml_hamil") {
            setJmlHamil(e.target.value)
        } else {
            setHamil(e.target.value)
        }

        setError({
            ...error,
            [e.target.name]: ""
        })
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        const findErrors = validate();
        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {
            handleNext()
        }
    }

    return (
        <Swipeable>
            <form id={id} onSubmit={handleSubmit} noValidate>
                <Grid container spacing={3}>

                    <Grid item xs={12} className={classes.textCenter}>
                        <Typography variant="h5" component="h1">{mode === 'edit' ? `Edit Form Stunting` : 'Form Stunting'}</Typography>
                        {/* {mode === 'edit' && <Typography>No KK: {no_kk}</Typography>} */}
                    </Grid>

                    <Grid item xs className={classes.textLeft}>
                        {
                            mode === "edit" && wilayah.status_draft && wilayah.status_draft === '1' ?
                                <> <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleDraft('local', 6, null)}
                                    disabled={isSubmitting.local || isSaved.local}
                                >
                                    <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                        }

                        {
                            mode === "edit" && (wilayah.status_draft === undefined || wilayah.status_draft === '2') ?
                                <>
                                    <FormControl
                                        variant="outlined">
                                        <Select
                                            id=""
                                            value=""
                                            name="segmen"
                                            onChange={handleCheckSegmen}
                                            displayEmpty
                                        >
                                            <MenuItem value=""> Segmen </MenuItem>
                                            <MenuItem value="0"> Wilayah </MenuItem>
                                            <MenuItem value="1"> Keluarga </MenuItem>
                                            <MenuItem value="2"> KB </MenuItem>
                                            <MenuItem value="3"> PK </MenuItem>
                                            <MenuItem value="4"> Stunting </MenuItem>
                                        </Select>
                                    </FormControl>
                                </> : <></>
                        }

                        {
                            mode !== "edit" ?
                                <> <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleDraft('local', 6, null)}
                                    disabled={isSubmitting.local || isSaved.local}
                                >
                                    <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                        }
                    </Grid>

                    <Grid item>
                        {
                            mode === "edit" && wilayah.status_sensus === 'Anomali' ?
                                <> <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleAnomali('local', 1)}
                                    disabled={isSubmitting.local || isSaved.local}
                                >
                                    <AssignmentTurnedInIcon /> Anomali Terkonfirmasi </Button> </> : <></>
                        }
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={12}>
                        <Slide direction={slide.direction} in={slide.in}>
                            <div className={classes.slideContent}>

                                <div className={classes.card}>
                                    <div className={classes.cardHeader}>
                                        <Typography margin="normal" paragraph>
                                            <span className={classes.badge}></span>{pertanyaan}</Typography>
                                    </div>
                                    <div className={classes.cardBody}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={3}>
                                                <FormControl error={error.sedang_hamil ? true : false} component="fieldset">
                                                    <RadioGroup value={sedang_hamil || ''}
                                                        onChange={handleChange}
                                                        aria-label="sedang_hamil" name="sedang_hamil">
                                                        <FormControlLabel control={<Radio />}
                                                            value="1"
                                                            label="1. Ya" />
                                                        <FormControlLabel control={<Radio />}
                                                            value="2"
                                                            label="2. Tidak" />
                                                    </RadioGroup>
                                                    <FormHelperText>{error.sedang_hamil}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            {sedang_hamil === '1' &&
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            fullWidth
                                                            label="Jumlah Keluarga Lainnya Hamil Pertama"
                                                            placeholder="1"
                                                            variant="outlined"
                                                            id="jml_hamil"
                                                            name="jml_hamil"
                                                            value={jml_hamil || ''}
                                                            onChange={handleChange}
                                                            InputProps={{

                                                                endAdornment: <InputAdornment
                                                                    className={classes.inputAdornmentNoWrap}
                                                                    position="end">Orang</InputAdornment>,
                                                            }}
                                                            type="number"
                                                            inputProps={{

                                                                className: classes.inputMini,
                                                                min: 0,
                                                                max: 48,
                                                                maxLength: 2
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            error={error.jml_hamil ? true : false}
                                                            helperText={error.jml_hamil}

                                                        />
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    </div>
                                </div>

                            </div>
                        </Slide>
                    </Grid>
                </Grid>

                <br />

                <Grid item xs style={{ marginTop: 20 }}>
                    <Button
                        ref={backRef}
                        // disabled={!isSomethingChange || isSubmitting}
                        onClick={handleBack}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

                    {isSubmitting && <CircularProgress size={14} />}
                    <Button
                        style={{ float: 'right' }}
                        ref={nextRef}
                        form={id}
                        disabled={isSubmitting}
                        type="submit">{sedang_hamil === 1 ? <>Selanjutnya</> : <>Selesai</>} <ChevronRight className={classes.iconRight} /></Button>
                </Grid>
            </form>

        </Swipeable>
    )
}

export default Hamil;